import { Flex, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import { ReactionType } from '../../store/personalBestStore';
import { useStores } from '../../store/rootStore';
import ContinueButton from '../../common/continueButton';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { trackOnboardingCollectedBaselineSpeedReaction } from '../../utils/analytics';

const CollectPersonalBest = observer(() => {
  const { personalBestStore, getNextPagePath } = useStores();
  const navigate = useNavigate();
  const baselineSpeedDescrip = '5.0';

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedBaselineSpeedReaction(
      baselineSpeedDescrip,
      personalBestStore.selectedReaction,
    );
    navigate(getNextPagePath('CollectPersonalBest'));
  };

  const handleClick = (selectedReaction: ReactionType) => {
    let personalBestDecrip = '6.0';
    let personalBestInTenths = 60;

    switch (selectedReaction) {
      case 'Easy':
        personalBestDecrip = '9.0';
        personalBestInTenths = 90;
        break;
      case 'Medium':
        personalBestDecrip = '7.0';
        personalBestInTenths = 70;
        break;
      case 'Hard':
        personalBestDecrip = '5.0';
        personalBestInTenths = 50;
        break;
      default:
        personalBestDecrip = '6.0';
        personalBestInTenths = 60;
        break;
    }

    trackOnboardingCollectedBaselineSpeedReaction(
      baselineSpeedDescrip,
      selectedReaction,
    );
    personalBestStore.setReactionAndPersonalBest(
      selectedReaction,
      personalBestDecrip,
      personalBestInTenths,
    );
  };

  return (
    <Container>
      <ProgressBar currentPage="CollectPersonalBest" />
      <PageHeader
        title={`How difficult is running with the treadmill set to ${baselineSpeedDescrip}?`}
      ></PageHeader>
      <Flex direction={'column'}>
        <RegularButton
          title="Easy"
          image="😌"
          isSelected={personalBestStore.selectedReaction === 'Easy'}
          onClick={() => handleClick('Easy')}
        />
        <RegularButton
          title="Medium"
          image="😮‍💨"
          isSelected={personalBestStore.selectedReaction === 'Medium'}
          onClick={() => handleClick('Medium')}
        />
        <RegularButton
          title="Hard"
          image="🥵"
          isSelected={personalBestStore.selectedReaction === 'Hard'}
          onClick={() => handleClick('Hard')}
        />
        <RegularButton
          title="No clue!"
          image="🤷"
          isSelected={personalBestStore.selectedReaction === 'No clue!'}
          onClick={() => handleClick('No clue!')}
        />
      </Flex>
      {personalBestStore.personalBestDecrip && (
        <Text
          margin={'5'}
          textAlign={'center'}
        >{`We'll set your personal best speed to ${personalBestStore.personalBestDecrip} to start, but you can always adjust this later!`}</Text>
      )}
      <BottomSpacer />
      <ContinueButton
        isDisabled={!personalBestStore.selectedReaction}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectPersonalBest;
